// UserAuthPageController
app.controller('UserAuthPageController', ['$scope', '$routeParams', 'sessionService',
    function($scope, $routeParams, sessionService) {

        $scope.errorLineDisplayFlag = false;
        $scope.errorMsg = undefined;

        $scope.init = async function() {
            $scope.showPageLoader();
            await $scope.fetchAdviserSiteDetails();

            setTimeout(async() => {
                let path = $routeParams.path;
                let action = $routeParams.action;
                let returnToken = $routeParams.returnToken == "true" ? true : $routeParams.returnToken;
                let sendCurrentToken = $routeParams.sendCurrentToken;
                await $scope.prepareBrokerLinks(path, action, returnToken, sendCurrentToken);
                $scope.hidePageLoader();
            }, 500);

            if ($routeParams.page == 'register')
                $scope.isTabActive = [true, false];
            else
                $scope.isTabActive = [false, true];

            if ($routeParams.action && sessionService.isLoggedIn()) {
                window.location.href = $routeParams.action;
            } else if ($routeParams.path && sessionService.isLoggedIn()) {

                if ($routeParams.returnToken == "true") {
                    if ($routeParams.path.includes(window.location.origin)) {
                        window.location.href = $routeParams.path
                    } else if ($routeParams.path.includes('?')) {
                        window.location.href = $routeParams.path + "&token=" + sessionService.get("refresh");
                    } else {
                        window.location.href = $routeParams.path + "?token=" + sessionService.get("refresh");
                    }
                } else
                    window.location.href = $routeParams.path
            }
        }


    }
]);